module.exports = __webpack_public_path__ + "img/emailreff.c36a131d.svg";